import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import App from "./app/App";
import "./styles.css";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer, { history } from "./app/rootReducer";
import { useLocation } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { BasePath } from "./app/consts";
import { getConfig } from "./app/config";
import { ConfigureLogger, Log, AuthService, AuthProvider } from "swyft-react-core";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ConfigProvider } from "./components/config/ConfigProvider";

const store = configureStore({
  reducer: rootReducer
});

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

ConfigureLogger(Log.INFO, console);

const queryClient = new QueryClient();

const config = getConfig();
const authService = new AuthService({
  authority: config.AuthAuthority,
  clientId: config.AuthClientId,
  basePath: BasePath,
  handleRedirectCallbackState: history.push
});

ReactDOM.render(
  <AuthProvider authService={authService}>
    <ConfigProvider>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ScrollToTop />
          <CookiesProvider>
            <QueryClientProvider client={queryClient}>
              <ReactQueryDevtools initialIsOpen={false} />
              <I18nextProvider i18n={i18n}>
                <App />
              </I18nextProvider>
            </QueryClientProvider>
          </CookiesProvider>
        </ConnectedRouter>
      </Provider>
    </ConfigProvider>
  </AuthProvider>,
  document.getElementById("root")
);
